import { render, staticRenderFns } from "./reviewSheet.vue?vue&type=template&id=40363362&scoped=true&"
import script from "./reviewSheet.vue?vue&type=script&lang=js&"
export * from "./reviewSheet.vue?vue&type=script&lang=js&"
import style0 from "./reviewSheet.vue?vue&type=style&index=0&id=40363362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40363362",
  null
  
)

export default component.exports